import { Interactions } from "../core/providers/interactions.provider.tsx";
import { usePractice } from "../core/providers/practice.provider.tsx";
import {
  appointmentView,
  appointmentsForPatient,
  type AgendaAppointmentView,
} from "../agenda/appointments.ts";
import { formatHour, todayLocal } from "../agenda/date-utils.ts";
import {
  AdvancedGrid,
  type GridColumn,
} from "../shared/advanced-grid/advanced-grid.component.tsx";

export function PatientRdvGridWidget({ panelId }: { panelId: string }) {
  const { current } = Interactions.usePatient();
  const { practice } = usePractice();

  if (!current) {
    return (
      <p className="px-1 text-xs text-sf-text-muted">
        Aucun patient sélectionné.
      </p>
    );
  }

  const rows = appointmentsForPatient(
    current.uuid,
    practice.uuid,
    todayLocal(),
    12,
  ).map((a) => appointmentView(a));

  const columns: GridColumn<AgendaAppointmentView>[] = [
    {
      id: "date",
      label: "Date",
      accessor: (r) => r.date,
      sortable: true,
      width: "110px",
      render: (r) => (
        <span className="tabular-nums text-sf-text-muted">
          {new Date(r.date).toLocaleDateString("fr-FR", {
            day: "numeric",
            month: "short",
          })}
        </span>
      ),
    },
    {
      id: "start",
      label: "Heure",
      accessor: (r) => r.start,
      sortable: true,
      width: "80px",
      render: (r) => (
        <span className="font-semibold tabular-nums">
          {formatHour(r.start)}
        </span>
      ),
    },
    {
      id: "motif",
      label: "Motif",
      accessor: (r) => r.motif,
      sortable: true,
      render: (r) => (
        <span className="inline-flex items-center gap-1.5">
          <span
            className="size-2 shrink-0 rounded-full"
            style={{ background: r.color }}
          />
          {r.motif}
        </span>
      ),
    },
    {
      id: "duration",
      label: "Durée",
      accessor: (r) => r.dur,
      sortable: true,
      width: "80px",
      align: "right",
      render: (r) => (
        <span className="tabular-nums text-sf-text-muted">
          {Math.round(r.dur * 60)} min
        </span>
      ),
    },
    {
      id: "practitioner",
      label: "Praticien",
      accessor: (r) => r.practitioner.name,
      sortable: true,
      width: "130px",
      defaultVisible: false,
    },
    {
      id: "chair",
      label: "Fauteuil",
      accessor: (r) => r.chair.shortLabel,
      sortable: true,
      width: "90px",
      defaultVisible: false,
    },
  ];

  return (
    <AdvancedGrid<AgendaAppointmentView>
      instanceId={panelId}
      columns={columns}
      rows={rows}
      rowKey={(r) => r.id}
      emptyMessage="Aucun RDV à venir."
    />
  );
}
